import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { AuthService, ConfigStateService } from '@abp/ng.core';
import { APP_ICONS } from '../../icons/app-icons';
import { ShoppingCartService } from '@proxy/shopping-carts';
import { finalize, take } from 'rxjs/operators';
import { SelectedSommelierService } from '../../services/selected-sommelier.service';
import { CartStateService } from '../../services/cart-state.service';
import { ModalCommunicationService } from '../../services/modal-communication.service';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'app-metro-product-card',
  templateUrl: './metro-product-card.component.html',
  standalone: false
})
export class MetroProductCardComponent implements OnInit {
  @Input() id!: number;
  @Input() name!: string;
  @Input() year!: string;
  @Input() stock!: number;
  @Input() maxOrder!: number;
  @Input() location!: string;
  @Input() price!: number;
  @Input() imageUrl!: string;
  @Input() customUserId?: string;
  @Input() disableDetailsNavigation = false;

  @Output() cardClick = new EventEmitter<number>();

  imageLoaded = false;
  hasError = false;
  private userId?: string;
  isAdding = false;
  addToCartIcon = APP_ICONS.cartPlus;

  constructor(
    private selectedSommelierService: SelectedSommelierService,
    private authService: AuthService,
    private config: ConfigStateService,
    private shoppingCartService: ShoppingCartService,
    private cartStateService: CartStateService,
    private notificationService: NotificationService,
    private modalCommunicationService: ModalCommunicationService
  ){}

  ngOnInit(): void {
    if (this.customUserId) {
      this.userId = this.customUserId;
    } else {
      this.config.getOne$('currentUser').pipe(take(1)).subscribe(user => {
        this.userId = user?.id;
      });
    }
  }

  get isAuthenticated(): boolean {
    return this.authService.isAuthenticated;
  }

  goToDetails() {
    if (this.disableDetailsNavigation) {
      this.cardClick.emit(this.id);
      return;
    }
    // Navega a {slug}/catalog/wine/{id}
    this.selectedSommelierService.navigate(['catalog', 'wine', this.id.toString()]);
  }

  onCatalogAddToCart(event: Event) {
    event.stopPropagation();

    if (this.isAdding) {
      return;
    }

    if (!this.isAuthenticated) {
      this.modalCommunicationService.triggerOpenRegisterModal();
      return;
    }

    if (!this.stock || this.stock <= 0) {
      return;
    }

    if (!this.userId) {
      return;
    }

    this.isAdding = true;

    this.shoppingCartService.addItem(this.userId, this.id, 1)
      .pipe(
        finalize(() => {
          this.isAdding = false;
        })
      )
      .subscribe({
        next: cart => {
          this.notificationService.success('', '::SuccessfullyAdded');
          if (!this.customUserId) {
            this.cartStateService.setCount(cart.totalItems ?? 0);
          }
        },
        error: err => {
          console.error('Failed to add wine to cart', err);
        }
      });
  }

  onImageError(event: Event) {
    const target = event.target as HTMLImageElement;
    target.src = 'assets/images/no-image.png'; // ruta a tu imagen por defecto
    this.hasError = true;
  }

  getCountryName(): string {
    return this.location?.split(',').pop()?.trim() ?? '';
  }


  get flagUrl(): string | null {
    const code = this.getCountryCode();
    return code ? `assets/images/flags/${code}.svg` : null;
  }


  getCountryCode(): string | null {
    if (!this.location) return null;

    const normalized = this.location.trim().toLowerCase();
    return this.countryCodeMap[normalized] ?? null;
  }

  private countryCodeMap: Record<string, string> = {
    argentina: 'ar',
    españa: 'es',
    spain: 'es',
    italia: 'it',
    italy: 'it',
    francia: 'fr',
    france: 'fr',
    australia: 'au',
    hungría: 'hu',
    hungary: 'hu'
  };



}
